import React from 'react';
//@ts-ignore
import Parse from 'parse';
//@ts-ignore
import {ShuffleArray,GetUserLocale,GetLocaleValue} from '../../themes/kent/utilities/functions';
//@ts-ignore
import {GeneralAssetUrl} from '../../themes/kent/utilities/constants';
/**
 *
 * Deep Link component
 * @extends {React.Component}
 */
interface IProps {
  product?: any;
}

interface IState {
  deepLinks?:any;
}

class DeepLinks extends React.Component<IProps,IState>{
  public state: IState;
  constructor(props: IProps) {
    super(props);
    this.state = {
      deepLinks:[]
    };
  }

  componentDidMount = async() => {
    let deepLinks: any = [];
    let deepLinkDeDupeArray: any = [];
    if(this.props.product){
      if(this.props.product.attributes){
        let productDeepLinks: any = this.props.product.attributes.deeplinks;
        let locale: any = GetLocaleValue();
        let deepLinkServerResponse: any = await Parse.Cloud.run('returnDeepLinks',{slug: this.props.product.attributes.slug,locale:locale})
        let deepLinkRetailers = deepLinkServerResponse.deepLinkRetailers;
        let site = 'hyperlite';
        if(typeof window !== "undefined"){
          if(window.location){
            if(window.location.href){
              if(window.location.href.indexOf('hyperlite') != -1){
                site = 'hyperlite';
              }
              if(window.location.href.indexOf('hosports') != -1){
                site = 'hosports';
              }
              if(window.location.href.indexOf('fatsac') != -1){
                site = 'fatsac';
              }
              if(window.location.href.indexOf('barefootinternational') != -1){
                site = 'barefoot';
              }
            }
          }
        }
        deepLinkRetailers = deepLinkRetailers.filter((retailer:any)=> retailer.attributes.site == site);
        console.log(deepLinkRetailers)
        ShuffleArray(deepLinkRetailers)
        if(deepLinkRetailers){
          for (let index = 0; index < deepLinkRetailers.length; index++) {
            let deepLinkRetailer = deepLinkRetailers[index];
            if(productDeepLinks[deepLinkRetailer.attributes.slug]){
              if(deepLinkDeDupeArray.indexOf(deepLinkRetailer.attributes.slug) == -1){
                deepLinks.push(
                  {
                    slug:deepLinkRetailer.attributes.slug,
                    link:productDeepLinks[deepLinkRetailer.attributes.slug],
                    image:deepLinkRetailer.attributes.image ? deepLinkRetailer.attributes.image.url() : ''
                  }
                )
                deepLinkDeDupeArray.push(deepLinkRetailer.attributes.slug)
              }
            }
          }
        }
        this.setState({
          deepLinks:deepLinks
        })
      }
    }
  }

  trackDeepLink = (data:any) => {
    var link = data.link;
    //var name = data.slug;
    /*
    ReactGA.event({
      category: 'DeepLinkClick',
      action: name,
      label: name
    });
    */
  //  window.open(link);
  console.log(link)
  }

  public render(): JSX.Element {
    if(!this.state.deepLinks) return <span />
    return (
      <div className="row full-width" style={{"maxWidth":"450px", marginTop:"10px"}}>
        <h6 className="full-width" style={{marginTop:'20px', marginBottom:'10px'}}>{'Buy Online'}</h6>
        {this.state.deepLinks && this.state.deepLinks.map((data:any,index:any) => {
          let image = data.image ? data.image : 'https://assets.hosports.com/img/deeplinks/'+data.slug+'.jpg'
          return(
            <div className="small-2 medium-2" style={{padding:"4px"}}>
              <div onClick={() => this.trackDeepLink(data)} style={{"cursor":"pointer"}}>
                <a style={{display:'block'}} target="_blank" href={data.link} onClick={() => this.trackDeepLink(data)}>
                  <img className="full-width circle deeplink-thumb background-image-fill" src={GeneralAssetUrl+'square.png'} style={{'backgroundImage':'url('+image+')'}} />
                </a>
              </div>
            </div>

          )})}
          <div className="small-2 medium-2" style={{padding:"4px"}}>
            <a style={{display:'block'}} href={'/dealerLocator'}>
              <img className="full-width circle deeplink-thumb background-image-fill" src={GeneralAssetUrl+'square.png'} style={{'backgroundImage':'url('+GeneralAssetUrl+'shop-local-icon.png)'}} />
            </a>
          </div>
        </div>
      )
    }
}

 export default DeepLinks;
